import { Link } from 'react-router-dom';
import { trackInteraction } from '../utils/interactions';

export default function ActionLink({ action, agencyId, source, targetType, href, to, children, ...props }) {
    const enabled = Boolean(to || href);
    const record = () => {
        if (enabled && source !== 'profile') void trackInteraction({ action, agencyId, source, targetType });
    };
    const shared = {
        ...props,
        'aria-disabled': enabled ? undefined : true,
        onClick: record,
        onAuxClick: event => { if (event.button === 1) record(); },
    };
    return to
        ? <Link {...shared} to={to}>{children}</Link>
        : <a {...shared} href={href || undefined}>{children}</a>;
}
